import { message } from 'antd';
import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { startSessionMonitor } from '../config/sessionMonitor';

export default function useSessionGuard(userId) {
  const dispatch = useDispatch();
  const history = useHistory();
  useEffect(() => {
    if (!userId) return undefined;
    return startSessionMonitor({
      userId,
      onEnd: (code) => {
        ['logedIn', 'token', 'userId'].forEach((key) => Cookies.remove(key));
        ['logedIn', 'token', 'userId', 'access_token'].forEach((key) => localStorage.removeItem(key));
        dispatch({ type: 'SESSION_ENDED' });
        message.warning(
          code === 'ACCOUNT_DISABLED'
            ? 'Your account access has been disabled. Please contact support.'
            : 'Your session has expired. Please sign in again.',
        );
        history.replace('/');
      },
    });
  }, [userId, dispatch, history]);
}
